import React from "react";
import SiteReviews from "../components/SiteReviews";
import Header from "../components/Header/Header"; // ✅ Import Header
import Footer from "../components/Footer/Footer"; // ✅ Import Footer
import "./reviewpage.css"; // new css file for styling

const ReviewsPage = () => {
  return (
    <div className="reviews-page">
      {/* Header Section */}
      <Header /> {/* ✅ Add Header here */}

      {/* Banner Section */}
      <div className="reviews-banner">
        {/* Overlay content can be added if needed */}
      </div>

      {/* Reviews Section */}
      <div className="reviews-section container">
<SiteReviews variant="grid" />      </div>

      {/* Footer Section */}
      <Footer /> {/* ✅ Add Footer here */}
    </div>
  );
};

export default ReviewsPage;
